module.exports = __webpack_public_path__ + "static/media/no-data.1c7e4e12.png";